module.exports = __webpack_public_path__ + "static/media/icon_4.728fd96f.svg";